import {
  fetchGSASearchResults,
  generateFetchParams,
} from "~/features/selectionAssistant/gearbox/fetchGSASearchResults";
import { useEffect, useRef, useState } from "react";
import { ACTIONS, type useGearboxSALogic } from "~/features/selectionAssistant/gearbox/useGearboxSALogic";
import { addBaseProductDataAction } from "~/domains/product/redux/actions";
import { useDispatch } from "react-redux";
import { transformSrpProduct } from "~/features/search/transformers/transformSrpProduct";
import { useOnMount } from "~/common/hooks/useOnMount";
import { loadCartAmounts } from "~/features/addToCart/redux/cartAmounts/actions";

export function useFetchGearboxSAData(
  state: ReturnType<typeof useGearboxSALogic>[0],
  dispatch: ReturnType<typeof useGearboxSALogic>[1],
  ignoreFirstTime: boolean = false,
) {
  const [ranOnce, setRanOnce] = useState(false);
  const fetchParams = generateFetchParams(state);
  const abortController = useRef<AbortController>();

  const reduxDispatch = useDispatch();

  useOnMount(() => {
    reduxDispatch(loadCartAmounts());
  });

  useEffect(() => {
    (async () => {
      if (!state.pageSize) {
        // Don't fetch if we don't have a page size calculated yet
        return;
      }
      if (ignoreFirstTime && !ranOnce) {
        setRanOnce(true);
      } else {
        dispatch(ACTIONS.searchStart(state.currentPage > 0 ? "loadingMore" : "searching"));
        abortController.current?.abort();
        try {
          const controller = new AbortController();
          abortController.current = controller;
          const data = await fetchGSASearchResults(fetchParams, controller.signal);
          const products = data.results.map(transformSrpProduct);
          reduxDispatch(addBaseProductDataAction(products));
          dispatch(ACTIONS.searchSuccess(data));
        } catch (e) {
          dispatch(ACTIONS.searchError());
        }
      }
    })();
  }, [fetchParams.toString()]);
}
